/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import clone from 'clone';
import moment from 'moment-timezone';
import {
  Container,
} from 'semantic-ui-react';

// components
import BookingTitle from '../../../components/Bookings/BookingTitle';
// structs
import { decodeSearch, encodeSearch } from '../../../utils/url';
import BOOKING_DEFAULT from '../../../structs/booking';
import BuyerBooking from '../../BuyerBooking';
import { CANCELLED_BOOKING_STATUSES } from '../../../constants/bookingStatuses';

moment.locale('en-gb');

class Buyer extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      creditCheckAccess: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    onCheck: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        noeticIsEnabled: PropTypes.bool,
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    fetchNewBooking: PropTypes.func,
    isMobile: PropTypes.bool,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, BOOKING_DEFAULT, props.data);
    if (!data.bankCases) {
      data.bankCases = [];
    }
    return {
      data,
      oriData: clone(data),
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = Buyer.getPropsToState(props);
    this.state = {
      ...state,
      bookingStatusModal: false,
      bbfLoading: false,
    };
    this.validation = {};
    this.loanBox = null;
  }
  componentWillReceiveProps(nextProps) {
    const state = Buyer.getPropsToState(nextProps);
    // don't allow state to override data if oriData is same
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.data = this.state.data;
    }
    this.setState({ ...state }, () => {
      const { store } = this.context;
      const { data } = this.state;
      if (data && data.id && !data.buyerProfileID && (!data.project.linkBuyerApp || CANCELLED_BOOKING_STATUSES.some(s => data.statusID === s.value))) {
        const query = decodeSearch(this.props.location.search);
        query.section = 'info';
        store.dispatch(replace(`/bookings/${data.id}/?${encodeSearch(query)}`));
      }
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }))
  render() {
    const { isMobile } = this.props;
    const { data, loading } = this.state;
    return (
      <Container className="no_margin">
        <BookingTitle isMobile={isMobile} data={data} />
        <BuyerBooking
          token={this.props.token}
          bookingID={data.id}
          setLoading={this.setLoading}
          loading={loading}
          location={this.props.location}
          booking={data}
          isMobile={isMobile}
        />
      </Container>
    );
  }
}

export default connect(Buyer.mapStateToProps)(Buyer);



// WEBPACK FOOTER //
// ./src/containers/Bookings/Overview/Buyer.jsx